import { EqualityFn, useStore } from "react-redux";
import { useSelector } from "react-redux";
import * as _ from "lodash";
import IAppStore from "app/IAppStore";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { StoreSelector } from "./storeSelector";
import IsLoaded from "common/isLoaded";

export default function useLazySelector<T>(
    selector: StoreSelector<T>, 
    loader: (dispatch: Dispatch) => any, 
    shouldLoad?: StoreSelector<boolean>, defaultValue?: T,
    equalityFn?: EqualityFn<T>): T {

    const storeValue = useSelector(selector, equalityFn);
    const store = useStore();
    const dispatch = useDispatch();

    const loadOnce = useCallback(_.once(loader), []);
    
    useEffect(() => {
        const state = <IAppStore>store.getState();

        if (selector(state) == null && (shouldLoad == null || shouldLoad(state))) {
            loadOnce(dispatch);
        }

    }, [store]);


    return storeValue ?? defaultValue;
}

const IsLoadedDefaultVal: any = { __uniqueval: -999 };

export function useLazyLoader<T>(
    selector: StoreSelector<T>, 
    loader: (dispatch: Dispatch) => any, 
    shouldLoad?: StoreSelector<boolean>, defaultValue?: T,
    equalityFn?: EqualityFn<T>): IsLoaded<T> {

    const data = useLazySelector(selector, loader, shouldLoad, IsLoadedDefaultVal as T, equalityFn);

    const isLoaded = data !== IsLoadedDefaultVal
    return {
        isLoaded: isLoaded,
        data: isLoaded ? data : defaultValue
    }
}

export const isCustomer: StoreSelector<boolean> = m => m.userState.isCustomer;
export const isNotCustomer: StoreSelector<boolean> = m => !m.userState.isCustomer;